import { render, staticRenderFns } from "./OrganismForgetPassword.vue?vue&type=template&id=4a0c6f18&"
import script from "./OrganismForgetPassword.vue?vue&type=script&lang=js&"
export * from "./OrganismForgetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports